import { Button, PlayLineIcon, SourceDataIcon } from '@lokalise/louis'
import clsx from 'clsx'
import overview from '../../../../assets/overview.svg'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../../constants/url'
import { DynamicRoutingAiIcon } from '../../../AiModelIcon/icons'
import { DescriptionWithIcon } from '../../../DescriptionWithIcon/DescriptionWithIcon'
import { StyledLink } from '../../../StyledLink/StyledLink'
import styles from './OverviewStep.module.css'

type OverviewStepProps = {
  profileName: string
  onNext: () => void
  onClose: () => void
}

export const OverviewStep = ({ profileName, onNext, onClose }: OverviewStepProps) => (
  <div className={clsx([styles.container, 'flex gap-7'])}>
    <div className="flex-col gap-6">
      <div className="flex-col gap-4">
        <h2 className={styles.heading}>{profileName} setup guide</h2>
        <p className={styles.subheading}>
          AI profile uses Translation Memories assigned in each project's settings to improve
          translation quality. Need more info? See the{' '}
          <StyledLink href={AI_PROFILES_DOCUMENTATION_URL} rel="noreferrer" target="_blank">
            docs.
          </StyledLink>
        </p>
      </div>
      <div className="flex-col gap-4">
        <h3 className={styles.stepsContainerHeading}>Your steps</h3>
        <DescriptionWithIcon
          title="Phase 1 - Models"
          description="Select model routing."
          icon={<DynamicRoutingAiIcon size="16px" />}
        />
        <DescriptionWithIcon
          title="Phase 2 - Translation Examples & Languages"
          description="Choose which past translations to use as examples and the languages that should use them."
          icon={<SourceDataIcon size="16px" />}
        />
        <DescriptionWithIcon
          title="Phase 3 - Activation"
          description="Select the projects which the AI profile should be applied to."
          icon={<PlayLineIcon size="16px" />}
        />
      </div>
      <div className={clsx([styles.footer, 'flex gap-3 items-end justify-end'])}>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onNext} variant="primary">
          Next
        </Button>
      </div>
    </div>
    <div className={styles.imageContainer}>
      <img alt="overview" src={overview} />
    </div>
  </div>
)
